import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * MentionText - Renderiza texto com menções clicáveis
 * 
 * Props:
 * - text: string - Texto com menções (@username)
 * - className: string - Classes CSS adicionais
 */
const MentionText = ({ text, className = '' }) => {
  const navigate = useNavigate();
  
  if (!text) return null;
  
  // Regex para encontrar menções
  const mentionRegex = /@(\w+)/g;
  const parts = [];
  let lastIndex = 0;
  let match;
  
  while ((match = mentionRegex.exec(text)) !== null) {
    // Texto antes da menção
    if (match.index > lastIndex) {
      parts.push({
        type: 'text',
        content: text.substring(lastIndex, match.index)
      });
    }
    
    // A menção
    parts.push({
      type: 'mention',
      content: match[0],
      username: match[1]
    });
    
    lastIndex = match.index + match[0].length;
  }
  
  // Texto depois da última menção
  if (lastIndex < text.length) {
    parts.push({
      type: 'text',
      content: text.substring(lastIndex)
    });
  }
  
  const handleMentionClick = (username) => {
    // Navegar para o perfil do usuário
    navigate(`/profile/${username}`);
  };
  
  return (
    <span className={className}>
      {parts.map((part, index) => {
        if (part.type === 'mention') {
          return (
            <span
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                handleMentionClick(part.username);
              }}
              className="text-[#C79F5E] hover:underline cursor-pointer font-medium"
            >
              {part.content}
            </span>
          );
        }
        return <span key={index}>{part.content}</span>;
      })}
    </span>
  );
};

// Função utilitária para extrair usernames de um texto
export const extractMentions = (text) => {
  if (!text) return [];
  const mentionRegex = /@(\w+)/g;
  const mentions = [];
  let match;
  
  while ((match = mentionRegex.exec(text)) !== null) {
    if (!mentions.includes(match[1])) {
      mentions.push(match[1]);
    }
  }
  
  return mentions;
};

export default MentionText;
